import React, { useState } from "react";
import Icon from "../Icon";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  options?: {
    value: string;
    label: string | React.ReactNode;
  }[];
  ref?: any;
  className?: string;
  radioGroupClassName?: string;
  radioGroupItemClassName?: string;
  radioGroupItemLabelClassName?: string;
}

const Input: React.FC<InputProps> = React.forwardRef<any, InputProps>(
  (
    {
      options,
      className,
      radioGroupClassName = "radio-group",
      radioGroupItemClassName = "radio-group__item",
      radioGroupItemLabelClassName = "radio-group__item__label",
      ...rest
    },
    ref,
  ) => {
    const [showPassword, setShowPassword] = useState(false);

    if (rest.type?.toLowerCase() === "radio") {
      const { type, defaultValue, ...restProps } = rest;
      const mappedOptions = options.map(({ value, label }) => (
        <div className={radioGroupItemClassName} key={value}>
          <input
            ref={ref}
            className={className}
            id={`${rest?.name}_${value}`}
            value={value || ""}
            aria-required={rest?.required}
            {...restProps}
            defaultChecked={rest?.defaultValue === value}
            type={type}
          />
          <label
            className={radioGroupItemLabelClassName}
            htmlFor={`${rest?.name}_${value}`}
          >
            {label}
          </label>
        </div>
      ));

      if (radioGroupClassName) {
        return <div className={radioGroupClassName}>{mappedOptions}</div>;
      }
      return mappedOptions;
    }

    if (rest.type?.toLowerCase() === "password") {
      return (
        <div className="position-relative">
          <input
            className={className}
            ref={ref}
            {...rest}
            type={showPassword ? "text" : "password"}
          />

          <span
            className="position-absolute top-50 end-0 translate-middle-y"
            style={{ marginTop: "2px", marginRight: "17px" }}
          >
            <button
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setShowPassword(!showPassword);
              }}
              type="button"
            >
              {showPassword ? (
                <Icon icon="visibility-off" alt="hide password icon" />
              ) : (
                <Icon icon="visibility-on" alt="show password icon" />
              )}
            </button>
          </span>
        </div>
      );
    }

    return (
      <input
        className={className}
        ref={ref}
        {...rest}
        onKeyDown={(e) => {
          if (
            rest?.type == "number" &&
            !e.key.match(/[0-9]/) &&
            !["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"].includes(
              e.key,
            )
          ) {
            e.preventDefault();
          }
        }}
      />
    );
  },
);

Input.displayName = "Input";

export default Input;
